import { jsx as _jsx } from "react/jsx-runtime";
import { BrandReviewsCarousel } from "@faire/retailer-visitor-shared/components/SearchProducts/BrandReviewsCarousel/index";
import { categoryPath } from "@faire/retailer-visitor-shared/paths/category/categoryPath";
import { suppliersPath } from "@faire/retailer-visitor-shared/paths/suppliers/suppliersPath";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageBrandTileReviewsResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageBrandTileReviewsResponse";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { trackSeoFeaturedBrandsOnCategoryPageCtaClick } from "@faire/web-api--source/events/seo/click/featuredBrandsOnCategoryPageCta";
import React from "react";
import styled from "styled-components";
export var LoggedOutCategoryPageBrandReviewsCarousel = function() {
    var categoryModel = useLoggedOutCategoryPageCurrentCategory();
    var routingContext = useRetailerRoutingContext();
    var brandPageQueryParameters = useLoggedOutCategoryPageCatNavResponse().data.brandPageQueryParams;
    var brands = useLoggedOutCategoryPageBrandTileReviewsResponse();
    if (!(brands === null || brands === void 0 ? void 0 : brands.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(BrandReviewsCarouselWrapper, {
        "data-test-id": "logged-out-category-page-featured-brands",
        children: /*#__PURE__*/ _jsx(BrandReviewsCarousel, {
            brands: brands,
            brandPageQueryParams: brandPageQueryParameters,
            ctaLink: (categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.isSuppliersPageCategoryValid) ? suppliersPath({
                urlIds: categoryModel.urlIds,
                routingContext: routingContext
            }) : categoryPath({
                urlIds: categoryModel.urlIds,
                routingContext: routingContext
            }),
            onCtaClick: function() {
                var _categoryModel_pathIdentifier;
                return trackSeoFeaturedBrandsOnCategoryPageCtaClick((_categoryModel_pathIdentifier = categoryModel.pathIdentifier) !== null && _categoryModel_pathIdentifier !== void 0 ? _categoryModel_pathIdentifier : "");
            }
        })
    });
};
var BrandReviewsCarouselWrapper = styled.div.withConfig({
    componentId: "sc-b81aadb5-0"
})([
    "margin:0;",
    "{margin:",
    ";}",
    "{margin-right:",
    ";margin-left:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(0, 12), responsiveMediaQueries.tablet, getSpacing(1), getSpacing(1));
